// -*- mode: RJSX; js-indent-level: 2; -*-

const FabSpacer = ({padding}) => {
  return (
    <div style={{height: '56px', padding: padding || 0}}/>
  );
};

export default FabSpacer;
